import { DSNCSeparator } from 'shared-definitions/types'
import { ApiComponentSeparator } from '../types.wp'

export function ncSeparator(_input: ApiComponentSeparator): DSNCSeparator {
  return {
    resource: 'nc-separator',
  }
}
